<template>
    <div class="content-body" style="padding-top: 6rem">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xl-9 col-xxl-12">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="card event-detail-bx overflow-hidden">
                                <div
                                    class="card-body"
                                    style="background: linear-gradient(270.02deg, #e20613 30.06%, #ff0000 83.32%); display: flex; align-items: center; justify-content: space-between">
                                    <div>
                                        <h2 class="title mb-3 text-white" style="margin: 0; padding: 0">
                                            Hi,
                                            <strong class="text-white">{{ message }}</strong>
                                        </h2>
                                        <p class="fs-14 text-white" style="margin: 0">
                                            Siap untuk memulai hari kamu
                                            <br />
                                            untuk mengetahui
                                            <strong>Dunia Printing!</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="media align-items-center">
                                        <span class="mr-4">
                                            <svg width="51" height="52" viewBox="0 0 51 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M25.5 43C34.8888 43 42.5 35.3888 42.5 26C42.5 16.6112 34.8888 9 25.5 9C16.1112 9 8.5 16.6112 8.5 26C8.5 35.3888 16.1112 43 25.5 43ZM25.5 51.5C39.5833 51.5 51 40.0833 51 26C51 11.9167 39.5833 0.5 25.5 0.5C11.4167 0.5 0 11.9167 0 26C0 40.0833 11.4167 51.5 25.5 51.5Z"
                                                    fill="white"
                                                    fill-opacity="0.18" />
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M33.9997 1.95836C31.9058 1.21807 29.72 0.75304 27.4976 0.578384C26.3965 0.491843 25.4997 1.39543 25.4997 2.5V6.86605C25.4997 7.97062 26.3981 8.854 27.4951 8.98264C29.8644 9.26046 32.1572 10.031 34.223 11.253C36.8645 12.8155 39.0379 15.0589 40.5159 17.7486C41.9939 20.4384 42.7223 23.4757 42.625 26.5433C42.5277 29.6108 41.6082 32.5959 39.9627 35.1866C38.3172 37.7772 36.006 39.8783 33.2707 41.2703C30.5355 42.6623 27.4766 43.294 24.4136 43.0995C21.3507 42.905 18.3963 41.8913 15.8591 40.1645C13.8749 38.814 12.2029 37.0662 10.9444 35.0397C10.3616 34.1013 9.1801 33.6636 8.18029 34.1331L4.2283 35.989C3.22848 36.4585 2.79178 37.6543 3.33818 38.6143C4.44093 40.5516 5.79093 42.3324 7.35106 43.9131C8.50759 45.0848 9.77958 46.1466 11.1519 47.0806C14.9279 49.6506 19.3249 51.1592 23.8834 51.4487C28.4418 51.7382 32.9943 50.798 37.0652 48.7264C41.136 46.6548 44.5756 43.5277 47.0246 39.6721C49.4736 35.8165 50.842 31.3739 50.9868 26.8085C51.1317 22.2432 50.0476 17.7228 47.8479 13.7197C45.6482 9.71663 42.4137 6.37787 38.4824 4.05236C37.0536 3.2072 35.5519 2.50715 33.9997 1.95836Z"
                                                    fill="#FE634E" />
                                            </svg>
                                        </span>
                                        <div class="media-body ml-1">
                                            <p class="mb-2">Award Post</p>
                                            <h3 class="mb-0 text-black font-w600">{{ totalAward }}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="media align-items-center">
                                        <span class="mr-4">
                                            <svg width="51" height="52" viewBox="0 0 51 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M25.5 43C34.8888 43 42.5 35.3888 42.5 26C42.5 16.6112 34.8888 9 25.5 9C16.1112 9 8.5 16.6112 8.5 26C8.5 35.3888 16.1112 43 25.5 43ZM25.5 51.5C39.5833 51.5 51 40.0833 51 26C51 11.9167 39.5833 0.5 25.5 0.5C11.4167 0.5 0 11.9167 0 26C0 40.0833 11.4167 51.5 25.5 51.5Z"
                                                    fill="white"
                                                    fill-opacity="0.18" />
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M33.9997 1.95836C31.9058 1.21807 29.72 0.75304 27.4976 0.578384C26.3965 0.491843 25.4997 1.39543 25.4997 2.5V6.86605C25.4997 7.97062 26.3981 8.854 27.4951 8.98264C29.8644 9.26046 32.1572 10.031 34.223 11.253C36.8645 12.8155 39.0379 15.0589 40.5159 17.7486C41.9939 20.4384 42.7223 23.4757 42.625 26.5433C42.5277 29.6108 41.6082 32.5959 39.9627 35.1866C38.3172 37.7772 36.006 39.8783 33.2707 41.2703C30.5355 42.6623 27.4766 43.294 24.4136 43.0995C21.3507 42.905 18.3963 41.8913 15.8591 40.1645C13.8749 38.814 12.2029 37.0662 10.9444 35.0397C10.3616 34.1013 9.1801 33.6636 8.18029 34.1331L4.2283 35.989C3.22848 36.4585 2.79178 37.6543 3.33818 38.6143C4.44093 40.5516 5.79093 42.3324 7.35106 43.9131C8.50759 45.0848 9.77958 46.1466 11.1519 47.0806C14.9279 49.6506 19.3249 51.1592 23.8834 51.4487C28.4418 51.7382 32.9943 50.798 37.0652 48.7264C41.136 46.6548 44.5756 43.5277 47.0246 39.6721C49.4736 35.8165 50.842 31.3739 50.9868 26.8085C51.1317 22.2432 50.0476 17.7228 47.8479 13.7197C45.6482 9.71663 42.4137 6.37787 38.4824 4.05236C37.0536 3.2072 35.5519 2.50715 33.9997 1.95836Z"
                                                    fill="#FE634E" />
                                            </svg>
                                        </span>
                                        <div class="media-body ml-1">
                                            <p class="mb-2">Produk Post</p>
                                            <div class="d-flex align-items-center">
                                                <h3 class="mb-0 mr-3 text-black font-w600">{{ totalProduct }}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="media align-items-center">
                                        <span class="mr-4">
                                            <svg width="51" height="52" viewBox="0 0 51 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M25.5 43C34.8888 43 42.5 35.3888 42.5 26C42.5 16.6112 34.8888 9 25.5 9C16.1112 9 8.5 16.6112 8.5 26C8.5 35.3888 16.1112 43 25.5 43ZM25.5 51.5C39.5833 51.5 51 40.0833 51 26C51 11.9167 39.5833 0.5 25.5 0.5C11.4167 0.5 0 11.9167 0 26C0 40.0833 11.4167 51.5 25.5 51.5Z"
                                                    fill="white"
                                                    fill-opacity="0.18" />
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M33.9997 1.95836C31.9058 1.21807 29.72 0.75304 27.4976 0.578384C26.3965 0.491843 25.4997 1.39543 25.4997 2.5V6.86605C25.4997 7.97062 26.3981 8.854 27.4951 8.98264C29.8644 9.26046 32.1572 10.031 34.223 11.253C36.8645 12.8155 39.0379 15.0589 40.5159 17.7486C41.9939 20.4384 42.7223 23.4757 42.625 26.5433C42.5277 29.6108 41.6082 32.5959 39.9627 35.1866C38.3172 37.7772 36.006 39.8783 33.2707 41.2703C30.5355 42.6623 27.4766 43.294 24.4136 43.0995C21.3507 42.905 18.3963 41.8913 15.8591 40.1645C13.8749 38.814 12.2029 37.0662 10.9444 35.0397C10.3616 34.1013 9.1801 33.6636 8.18029 34.1331L4.2283 35.989C3.22848 36.4585 2.79178 37.6543 3.33818 38.6143C4.44093 40.5516 5.79093 42.3324 7.35106 43.9131C8.50759 45.0848 9.77958 46.1466 11.1519 47.0806C14.9279 49.6506 19.3249 51.1592 23.8834 51.4487C28.4418 51.7382 32.9943 50.798 37.0652 48.7264C41.136 46.6548 44.5756 43.5277 47.0246 39.6721C49.4736 35.8165 50.842 31.3739 50.9868 26.8085C51.1317 22.2432 50.0476 17.7228 47.8479 13.7197C45.6482 9.71663 42.4137 6.37787 38.4824 4.05236C37.0536 3.2072 35.5519 2.50715 33.9997 1.95836Z"
                                                    fill="#FE634E" />
                                            </svg>
                                        </span>
                                        <div class="media-body ml-1">
                                            <p class="mb-2">Recap Post</p>
                                            <div class="d-flex align-items-center">
                                                <h3 class="mb-0 mr-3 text-black font-w600">{{ totalRecap }}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- fitur konsultasi -->

                        <div class="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
                            <div class="card">
                                <div class="card-header border-0 pb-0 d-sm-flex d-block">
                                    <h4 class="card-title mb-1">
                                        Total yang bertanya |
                                        <span class="fs-12">Ditampilkan 5 dari data terakhir</span>
                                    </h4>

                                    <div class="dropdown ml-auto text-right">
                                        <div class="">
                                            <a class="dropdown-item" href="/contact-form">Lihat Semua</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive recentOrderTable">
                                        <table class="table verticle-middle table-responsive-md">
                                            <thead class="fs-16 fw-semibold text-dark">
                                                <tr>
                                                    <th scope="col" class="fs-16 fw-semibold">No.</th>
                                                    <th scope="col" class="fs-14">Pesan</th>
                                                    <th scope="col" class="fs-14">Subject</th>
                                                    <th scope="col" class="fs-14">Nama</th>
                                                    <th scope="col" class="fs-14">Kontak</th>
                                                    <th scope="col" class="fs-14">Tanggal</th>
                                                    <th scope="col" class="fs-14"></th>
                                                </tr>
                                            </thead>
                                            <tbody v-for="(item, index) in latestContacts" :key="item.id">
                                                <tr>
                                                    <td>#{{ index + 1 }}</td>
                                                    <td class="fs-12 text-black text-ellipsis" :title="item.deskripsi">
                                                        {{ item.deskripsi }}
                                                    </td>

                                                    <td>
                                                        <span class="badge light badge-success btn-xxs">
                                                            <i class="fa fa-circle text-success mr-1 fs-12"></i>
                                                            {{ item.jenis }}
                                                        </span>
                                                    </td>
                                                    <td class="fs-14 text-black text-ellipsis">{{ item.nama }}</td>
                                                    <td class="fs-12 text-black text-ellipsis">+(62) {{ item.no_tlp }}</td>
                                                    <td class="fs-12 text-black text-ellipsis">{{ formatDate(item.created_date) }}</td>

                                                    <td>
                                                        <!-- Updated "view" button -->

                                                        <a @click="viewDetails(item)" class="btn btn-primary shadow btn-xs sharp mr-1"><i class="fa fa-eye color-muted"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- batas -->
                    </div>
                </div>
                <!-- batas -->
                <div class="col-xl-3 col-xxl-12 mb-4">
                    <div class="bg-white rounded mb-4">
                        <div class="align-self-start">
                            <div class="card-header border-0 pb-0">
                                <h2 class="card-title">Analisa Career</h2>
                            </div>
                            <div class="card-body pb-0">
                                <p>Lowongan yang banyak diminati</p>
                                <ul class="list-group list-group-flush">
                                    <li v-for="(item, index) in careerStats" :key="index" class="list-group-item d-flex px-0 justify-content-between">
                                        <strong>{{ item.name }}</strong>
                                        <span class="mb-0">{{ item.total }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-footer pt-0 pb-0 text-center">
                                <div class="row">
                                    <div class="col-6 pt-3 pb-3 border-right">
                                        <h3 class="mb-1 text-primary">{{ genderStats.laki }}</h3>
                                        <span>Laki-Laki</span>
                                    </div>
                                    <div class="col-6 pt-3 pb-3">
                                        <h3 class="mb-1 text-primary">{{ genderStats.perempuan }}</h3>
                                        <span>Perempuan</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- batas -->
                    <!-- <div class="bg-white rounded mb-4">
                        <div class="card-header border-0 pb-sm-0 pb-5">
                            <div class="d-flex align-items-end">
                                <div class="mr-auto">
                                    <h4 class="fs-20">Site Visit</h4>
                                </div>
                            </div>
                            <span class="badge badge-sm light badge-primary">Active</span>
                        </div>
                        <div class="card">
                            <div class="p-4">
                                <div class="card p-3 mb-3" style="background-color: #f5e7e8">
                                    <p class="font-w600"><a href="event.html" class="text-black">The Story’s of Danau Toba (Drama Theater)</a></p>
                                    <div class="d-flex align-items-end">
                                        <div class="mr-auto">
                                            <span class="fs-12">2m ago</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- Detail Modal Component -->
        <ModalContactForm v-if="showModal" :showModal="showModal" :selectedItem="selectedItem" @close="closeModal" />
    </div>
</template>
<script>
// import PreLoader from "../components/PreLoader.vue";
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import axiosInstance from "../axios";
import ModalContactForm from "@/components/modal/ModalContactForm.vue";
import Award from "./Award.vue";

export default {
    components: {
        ModalContactForm,
    },
    name: "Dashboard",
    methods: {
        formatDate(dateStr) {
            const date = new Date(dateStr);

            const day = date.getDate(); // 2 (tanpa 0 di depan)
            const month = date.toLocaleString("id-ID", { month: "short" }); // Feb
            const year = date.getFullYear();

            const hour = String(date.getHours()).padStart(2, "0");
            const minute = String(date.getMinutes()).padStart(2, "0");

            return `${day} ${month} ${year} - ${hour}.${minute}`;
        },
    },

    setup() {
        // const { proxy } = getCurrentInstance();
        const message = ref("You are not logged in!");
        const store = useStore();
        const router = useRouter();
        const user = ref(null);
        const tK = ref([]);
        const careers = ref([]);
        const showModal = ref(false);
        const selectedItem = ref(null);
        // data blogs Award produk dan events
        const totalAward = ref(0);
        const totalBlog = ref(0); //ini tidak terpakai
        const totalProduct = ref(0);
        const totalRecap = ref(0);

        // batas

        const isAuthenticated = computed(() => store.getters.isAuthenticated);
        const token = computed(() => store.getters.token);
        const tokenExpiry = computed(() => store.getters.tokenExpiry);
        const checkAuth = () => {
            if (!token.value || new Date(tokenExpiry.value) < new Date() || !isAuthenticated.value) {
                Swal.fire({
                    title: "Error",
                    text: `Session expired or invalid`,
                    icon: "error",
                    confirmButtonText: "OK",
                }).then(() => {
                    store.dispatch("setAuth", false);
                    store.dispatch("setToken", { token: null, expiry: null });
                    localStorage.clear();
                    window.location.href = "/";
                });
                return false;
            }
            return true;
        };

        // user
        const fetchUserData = async () => {
            if (!checkAuth()) return;

            try {
                const response = await axiosInstance.get("/user", {
                    headers: {
                        Authorization: `Bearer ${token.value}`,
                        "Content-Type": "application/json",
                    },
                });

                if (response.status === 200) {
                    const content = await response.data;
                    user.value = content;
                    message.value = `${content.name}`;
                } else {
                    Swal.fire({
                        title: "Error",
                        text: `Error: ${response.status} ${response.statusText}`,
                        icon: "error",
                        confirmButtonText: "OK",
                    }).then(() => {
                        store.dispatch("setAuth", false);
                        store.dispatch("setToken", { token: null, expiry: null });
                        localStorage.clear();
                        router.replace({ name: "Login" });
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: `Session expired. Please log in again.`,
                    icon: "error",
                    confirmButtonText: "OK",
                }).then(() => {
                    message.value = "Session expired. Please log in again.";
                    store.dispatch("setAuth", false);
                    store.dispatch("setToken", { token: null, expiry: null });
                    localStorage.clear();
                    router.replace({ name: "Login" });
                });
            }
        };
        // batas

        // Contact form layanan konsultasi

        const fetchData = async () => {
            try {
                const response = await axiosInstance.get("/contact-form-cms", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                if (response.status === 200 && response.data.code === 200) {
                    tK.value = response.data.data;
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: `Error: ${error.message}`,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        };

        const viewDetails = async (item) => {
            try {
                const response = await axiosInstance.get(`/contact-form-cms-id/${item.id}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                // Check the response and set the selected item
                if (response.status === 200 && response.data.code === 200) {
                    selectedItem.value = response.data.data;
                    showModal.value = true; // Open the modal
                } else {
                    throw new Error("User not found");
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    Swal.fire({
                        title: "Error",
                        text: "User not found.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: `Failed to fetch details: ${error.message}`,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            }
        };

        const closeModal = () => {
            showModal.value = false;
            selectedItem.value = null;
        };

        // looping
        const latestContacts = computed(() => {
            return [...tK.value].sort((a, b) => new Date(b.created_date) - new Date(a.created_date)).slice(0, 5);
        });

        // batas

        // ambil data career

        const fetchDataCareer = async () => {
            try {
                const response = await axiosInstance.get("/pelamar-cms", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });
                // console.log("RESPONSE DATA:", response.data);

                if (response.status === 200 && response.data.code === 200) {
                    careers.value = response.data.data;
                }
            } catch (error) {
                console.error("ERROR CAREER:", error);
                Swal.fire({
                    title: "Error",
                    text: error.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        };

        // grouping job / posisi
        const careerStats = computed(() => {
            const map = {};

            careers.value.forEach((item) => {
                const key = item.name_type || "Lainnya";
                map[key] = (map[key] || 0) + 1;
            });

            return Object.entries(map).map(([name, total]) => ({
                name,
                total,
            }));
        });

        // hitung gender
        const genderStats = computed(() => {
            let laki = 0;
            let perempuan = 0;

            careers.value.forEach((item) => {
                if (item.jenis_kelamin === "pria" || item.jenis_kelamin === "laki-laki") {
                    laki++;
                } else if (item.jenis_kelamin === "wanita" || item.jenis_kelamin === "perempuan") {
                    perempuan++;
                }
            });

            return {
                laki,
                perempuan,
            };
        });

        // batas

        // ================================== looping total artikel dari award, blogs, produk dan event recap
        //    data dari Award,blog, produk, dan event recap
        // - blog-kategori/${id_kategori} blogs dan award, RECAP
        // - /product product

        const fetchTotalPosts = async () => {
            try {
                const headers = {
                    Authorization: `Bearer ${token.value}`,
                    "Content-Type": "application/json",
                };

                // ⚠️ ganti ID kategori sesuai punyamu
                const AWARD_ID = 1;
                const BLOG_ID = 2;
                const RECAP_ID = 2;

                const [awardRes, blogRes, productRes, recapRes] = await Promise.all([
                    axiosInstance.get(`/blog-kategori/${AWARD_ID}`, { headers }),
                    axiosInstance.get(`/blog-kategori/${BLOG_ID}`, { headers }), //ini tidak terpakai
                    axiosInstance.get(`/product`, { headers }),
                    axiosInstance.get(`/blog-kategori/${RECAP_ID}`, { headers }),
                ]);

                // asumsi struktur: data.data = array
                totalAward.value = awardRes.data?.data?.length || 0;
                totalBlog.value = blogRes.data?.data?.length || 0; //ini tidak terpakai
                totalProduct.value = productRes.data?.data?.length || 0;
                totalRecap.value = recapRes.data?.data?.length || 0;
            } catch (error) {
                console.error("ERROR TOTAL POSTS:", error);
            }
        };

        // ==================================

        onMounted(() => {
            fetchUserData();
            fetchData();
            fetchDataCareer();
            fetchTotalPosts();
        });

        onMounted(fetchUserData);

        watch([isAuthenticated, token], async ([newAuth, newToken]) => {
            if (newAuth && newToken) {
                await fetchUserData();
            }
        });

        return {
            message,
            user,
            fetchUserData,
            fetchData,
            careers,
            tK,
            latestContacts,
            careerStats,
            genderStats,
            viewDetails,
            showModal,
            selectedItem,
            closeModal,
            totalAward,
            totalBlog,
            totalProduct,
            totalRecap,
            fetchTotalPosts,
        };
    },
};
</script>

<style scoped>
.content-body {
    background: #f4f4f9;
}

.modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px);
}

.modal.show .modal-dialog {
    transform: translate(0, 0);
}

.modal-body {
    position: relative;
    padding: 20px;
}

.card-apps {
    border-radius: 15px;
    color: #fff;
}

.icon-member {
    margin-right: 10px;
}

.name-profile {
    margin-bottom: 10px;
}

.progress-bar {
    background: linear-gradient(95.46deg, #ed1c24 -20.2%, #f57e20 128.85%);
}

.event-detail-bx {
    border-radius: 15px;
}

.img-card-events {
    width: 100%;
    border-radius: 50%;
}

.title {
    font-size: 24px;
    font-weight: 600;
}

.fs-12 {
    font-size: 12px;
}

.fs-14 {
    font-size: 14px;
}

.fs-18 {
    font-size: 18px;
}

.fs-35 {
    font-size: 35px;
}

.font-w600 {
    font-weight: 600;
}

.text-black {
    color: #000;
}

.text-ellipsis {
    max-width: 260px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
